var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 56,
    viewBox: "0 0 168 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.599 14.0127H69.9883V25.5337H72.599V14.0127Z",
    fill: "#7A59A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.536 14.0127L83.1548 21.4182V14.0127H85.6325V25.532H83.2537L77.652 18.1435V25.532H75.1572V14.0127H77.536Z",
    fill: "#7A59A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4822 14.0127L96.4669 16.1681H90.7816V18.9995H96.0031V21.1719H90.7816V25.532H88.1709V14.0127H96.4822Z",
    fill: "#7A59A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1814 22.2506C97.8165 21.4438 97.6357 20.6081 97.6357 19.7419C97.6357 19.0625 97.75 18.395 97.9751 17.7427C98.2002 17.0905 98.5378 16.496 98.9914 15.9576C99.5303 15.2986 100.163 14.7924 100.891 14.4357C101.617 14.0791 102.383 13.8786 103.188 13.8345H103.22C103.309 13.8345 103.382 13.8684 103.444 13.9347C103.505 13.9992 103.541 14.0825 103.551 14.181V15.6111C103.551 15.82 103.435 15.9355 103.203 15.9576C102.709 16.0018 102.235 16.1411 101.783 16.3771C101.331 16.6132 100.952 16.9292 100.644 17.3232C100.049 18.0468 99.7502 18.8638 99.7502 19.7742C99.7502 20.3228 99.8662 20.851 100.098 21.3623C100.33 21.8718 100.659 22.3084 101.089 22.6701C101.815 23.2629 102.63 23.5585 103.532 23.5585C104.083 23.5585 104.612 23.443 105.118 23.2137C105.625 22.9827 106.054 22.6481 106.406 22.2098C106.702 21.8583 106.926 21.4727 107.074 21.0498C107.224 20.6285 107.298 20.1971 107.298 19.7589C107.298 19.1338 107.159 18.5529 106.885 18.0145C106.83 17.9058 106.803 17.7954 106.803 17.6867C106.803 17.544 106.868 17.4183 107.001 17.3079C107.09 17.2536 107.26 17.1381 107.512 16.9631C107.765 16.7882 107.925 16.6778 107.992 16.6336C108.08 16.5793 108.162 16.5521 108.241 16.5521C108.418 16.5521 108.549 16.6336 108.638 16.7984C109.167 17.719 109.431 18.7126 109.431 19.7759C109.431 20.4672 109.317 21.1381 109.085 21.792C108.853 22.4442 108.512 23.0404 108.06 23.5772C107.521 24.2684 106.846 24.7967 106.037 25.1636C105.229 25.5321 104.383 25.7139 103.502 25.7139C102.808 25.7139 102.136 25.5967 101.486 25.3606C100.836 25.1245 100.26 24.7814 99.7519 24.333C99.0664 23.7504 98.5446 23.0574 98.1814 22.2506Z",
    fill: "#7A59A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3671 30.4629L77.9841 37.8701V30.4629H80.4635V41.9839H78.083L72.483 34.5937V41.9839H69.9883V30.4629H72.3671Z",
    fill: "#282827"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8105 30.4629V32.62H85.6137V35.1202H91.1983V37.2773H85.6137V39.8285H91.9912V41.9839H83.0029V30.4629H91.8105Z",
    fill: "#282827"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.562 30.4629V32.6693H99.0268V41.9839H96.4144V32.6693H92.8965V30.4629H102.562Z",
    fill: "#282827"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.498 30.4629L107.926 39.1542L110.341 30.4629H112.9L115.346 39.1542L117.759 30.4629H120.436L116.601 41.9839H113.908L111.579 33.7716L109.198 41.9839H106.506L102.689 30.4629H105.498Z",
    fill: "#282827"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M121.749 38.7023C121.384 37.8955 121.203 37.0598 121.203 36.1936C121.203 35.5142 121.317 34.8466 121.542 34.1944C121.768 33.5422 122.105 32.9477 122.559 32.4093C123.098 31.7503 123.73 31.2441 124.458 30.8874C125.185 30.5307 125.95 30.3303 126.755 30.2861H126.788C126.876 30.2861 126.95 30.3201 127.011 30.3863C127.073 30.4509 127.108 30.5341 127.119 30.6326V32.0628C127.119 32.2717 127.003 32.3872 126.771 32.4093C126.276 32.4534 125.802 32.5927 125.35 32.8288C124.898 33.0649 124.52 33.3808 124.211 33.7749C123.616 34.4984 123.318 35.3154 123.318 36.2258C123.318 36.7745 123.434 37.3044 123.665 37.8139C123.897 38.3235 124.227 38.76 124.656 39.1218C125.383 39.7146 126.198 40.0101 127.1 40.0101C127.651 40.0101 128.179 39.8946 128.686 39.6653C129.192 39.4343 129.622 39.0997 129.973 38.6615C130.27 38.3099 130.493 37.9243 130.642 37.5014C130.792 37.0802 130.865 36.6488 130.865 36.2106C130.865 35.5855 130.727 35.0046 130.452 34.4662C130.398 34.3575 130.37 34.2471 130.37 34.1367C130.37 33.994 130.435 33.8683 130.568 33.7579C130.657 33.7035 130.827 33.588 131.08 33.4131C131.332 33.2381 131.493 33.1277 131.559 33.0836C131.648 33.0292 131.73 33.0021 131.808 33.0021C131.985 33.0021 132.117 33.0836 132.204 33.2483C132.732 34.1689 132.997 35.1626 132.997 36.2258C132.997 36.9171 132.882 37.5897 132.65 38.242C132.418 38.8942 132.077 39.4904 131.626 40.0271C131.087 40.7184 130.411 41.2466 129.603 41.6135C128.793 41.9821 127.949 42.1638 127.067 42.1638C126.373 42.1638 125.702 42.0466 125.052 41.8105C124.402 41.5745 123.826 41.2314 123.318 40.7829C122.634 40.2021 122.112 39.5074 121.749 38.7023Z",
    fill: "#282827"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.283 41.9839L140.448 38.6922H140.199H137.787V41.9839H135.176V30.4629H140.198C143.223 30.4629 144.94 31.91 144.94 34.4629C144.94 36.2395 144.179 37.5236 142.774 38.1826L145.237 41.9839H142.283ZM137.788 36.5198H140.201C141.639 36.5198 142.466 35.8608 142.466 34.5444C142.466 33.2603 141.64 32.6183 140.201 32.6183H137.788V36.5198Z",
    fill: "#282827"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154.737 41.9839L151.415 37.2926L149.746 39.1372V41.9839H147.137V30.4629H149.746V35.696L154.556 30.4629H157.578L153.233 35.2697L157.876 41.9839H154.737Z",
    fill: "#282827"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M163.323 32.5705C162.446 32.5705 161.853 32.8831 161.853 33.5081C161.853 35.6313 168.015 34.4457 168 38.5935C168 40.8491 166.034 42.0652 163.473 42.0652C161.573 42.0652 159.672 41.3417 158.367 40.2393L159.407 38.1162C160.598 39.1693 162.282 39.8453 163.505 39.8453C164.579 39.8453 165.224 39.4495 165.224 38.7429C165.224 36.5705 159.06 37.8376 159.06 33.7561C159.06 31.6669 160.86 30.3489 163.537 30.3489C165.157 30.3489 166.776 30.8431 167.932 31.599L166.924 33.7544C165.701 33.0308 164.247 32.5705 163.323 32.5705Z",
    fill: "#282827"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4847 0.00170017C22.6489 0.20722 18.9961 1.15329 15.5262 2.83142C12.0598 4.51295 9.03711 6.90446 6.46322 10.0059C4.30881 12.5401 2.69128 15.3461 1.6158 18.4221C0.536873 21.4998 0 24.6403 0 27.8454C0 31.9287 0.866596 35.8726 2.59979 39.6739C4.33471 43.4735 6.82919 46.7448 10.0884 49.4845C12.5035 51.6059 15.2638 53.2229 18.366 54.3321C20.9675 55.2663 23.6467 55.8013 26.3984 55.9524C24.1231 54.9164 22.0516 53.583 20.1855 51.9456C16.9263 49.2076 14.43 45.9363 12.6951 42.135C10.9637 38.3355 10.0953 34.3915 10.0953 30.3066C10.0953 29.8989 10.104 29.4913 10.1229 29.0854C10.1005 28.7253 10.0867 28.3652 10.0867 28C10.0867 25.0106 10.791 22.2369 12.1703 19.6739C13.2285 17.0667 14.6907 14.665 16.5603 12.4654C19.1342 9.36391 22.1569 6.9724 25.6233 5.29087C26.4778 4.87813 27.3427 4.50956 28.2179 4.18514V1.62887C28.1644 1.16178 27.9918 0.776223 27.7035 0.463696C27.4152 0.154567 27.0596 0 26.6418 0H26.4847V0.00170017Z",
    fill: "url(#paint0_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.422 13.1856C49.1078 13.3945 48.3448 13.9109 47.1364 14.7363C45.928 15.5652 45.1132 16.107 44.692 16.3652C44.0619 16.8816 43.746 17.4794 43.746 18.1504C43.746 18.6667 43.8755 19.1848 44.1413 19.7011C45.4533 22.2353 46.111 24.975 46.111 27.9236C46.111 29.9924 45.7571 32.0204 45.0476 34.0111C44.3381 36.0017 43.273 37.8242 41.8557 39.4786C40.1726 41.5474 38.1235 43.1236 35.7049 44.209C33.5661 45.1703 31.3461 45.7037 29.0449 45.8141C31.8605 47.465 34.9229 48.299 38.2374 48.299C40.8648 48.299 43.3852 47.7572 45.8037 46.6701C48.2222 45.5831 50.2714 44.0068 51.9545 41.9397C52.8573 40.8867 53.6014 39.7572 54.2176 38.5665C54.3609 38.2149 54.499 37.8599 54.6268 37.5015C55.4934 35.0828 56.0147 32.6047 56.2011 30.0739C56.2512 29.386 56.2823 28.6947 56.2823 28C56.2823 24.8187 55.7696 21.7733 54.7545 18.862C54.1693 17.1839 53.4184 15.5499 52.4965 13.9601C52.0753 13.1839 51.4452 12.7983 50.6063 12.7983C50.2351 12.7983 49.8432 12.9274 49.422 13.1856Z",
    fill: "url(#paint1_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6229 5.2925C22.1548 6.97403 19.132 9.36384 16.5599 12.467C14.6903 14.6666 13.2281 17.0683 12.1699 19.6755C12.7689 18.5596 13.4836 17.4793 14.345 16.4449C15.8141 14.5834 17.6284 13.0972 19.7846 11.9863C21.9407 10.8738 24.2004 10.2148 26.5654 10.0076C27.6685 9.90397 28.2209 9.36214 28.2209 8.3787V4.18677C27.3423 4.51118 26.4774 4.87806 25.6229 5.2925Z",
    fill: "url(#paint2_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6229 5.2925C22.1548 6.97403 19.132 9.36384 16.5599 12.467C14.6903 14.6666 13.2281 17.0683 12.1699 19.6755C12.7689 18.5596 13.4836 17.4793 14.345 16.4449C15.8141 14.5834 17.6284 13.0972 19.7846 11.9863C21.9407 10.8738 24.2004 10.2148 26.5654 10.0076C27.6685 9.90397 28.2209 9.36214 28.2209 8.3787V4.18677C27.3423 4.51118 26.4774 4.87806 25.6229 5.2925Z",
    fill: "url(#paint3_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0957 30.3067C10.0957 34.3899 10.964 38.3339 12.6955 42.1351C14.4304 45.9347 16.9249 49.206 20.1859 51.9458C22.052 53.5831 24.1235 54.9165 26.3988 55.9526C26.9253 55.9814 27.4518 56.0001 27.9835 56.0001C32.187 56.0001 36.2213 55.1356 40.083 53.4014C43.9447 51.6689 47.1625 49.1755 49.7399 45.9177C51.6423 43.6808 53.1338 41.2298 54.2179 38.5683C53.6016 39.7589 52.8593 40.8884 51.9547 41.9415C50.2716 44.0103 48.2225 45.5865 45.804 46.6719C43.3854 47.7589 40.865 48.3007 38.2376 48.3007C34.9232 48.3007 31.8607 47.4668 29.0452 45.8158C28.7448 45.8311 28.4427 45.8396 28.1389 45.8396C23.8283 45.8396 19.9407 44.4434 16.4709 41.6511C14.4235 39.9441 12.8457 37.8906 11.7426 35.4855C10.7931 33.4184 10.2562 31.2867 10.1216 29.0872C10.1061 29.4914 10.0957 29.899 10.0957 30.3067Z",
    fill: "url(#paint4_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0957 30.3067C10.0957 34.3899 10.964 38.3339 12.6955 42.1351C14.4304 45.9347 16.9249 49.206 20.1859 51.9458C22.052 53.5831 24.1235 54.9165 26.3988 55.9526C26.9253 55.9814 27.4518 56.0001 27.9835 56.0001C32.187 56.0001 36.2213 55.1356 40.083 53.4014C43.9447 51.6689 47.1625 49.1755 49.7399 45.9177C51.6423 43.6808 53.1338 41.2298 54.2179 38.5683C53.6016 39.7589 52.8593 40.8884 51.9547 41.9415C50.2716 44.0103 48.2225 45.5865 45.804 46.6719C43.3854 47.7589 40.865 48.3007 38.2376 48.3007C34.9232 48.3007 31.8607 47.4668 29.0452 45.8158C28.7448 45.8311 28.4427 45.8396 28.1389 45.8396C23.8283 45.8396 19.9407 44.4434 16.4709 41.6511C14.4235 39.9441 12.8457 37.8906 11.7426 35.4855C10.7931 33.4184 10.2562 31.2867 10.1216 29.0872C10.1061 29.4914 10.0957 29.899 10.0957 30.3067Z",
    fill: "url(#paint5_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.00224417,
    y1: 27.976,
    x2: 56.2809,
    y2: 27.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8459A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1156,
    stopColor: "#7A56A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3984,
    stopColor: "#6750A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6897,
    stopColor: "#5C4D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584C9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -572.728,
    y1: 30.5494,
    x2: 56.2806,
    y2: 30.5494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8459A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1156,
    stopColor: "#7A56A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3984,
    stopColor: "#6750A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6897,
    stopColor: "#5C4D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584C9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -0.00265149,
    y1: 11.9304,
    x2: 56.2805,
    y2: 11.9304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8459A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1156,
    stopColor: "#7A56A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3984,
    stopColor: "#6750A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6897,
    stopColor: "#5C4D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584C9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 10.0953,
    y1: 11.9304,
    x2: 66.3785,
    y2: 11.9304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A177B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#9570B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3033,
    stopColor: "#7A60A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5266,
    stopColor: "#6755A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7558,
    stopColor: "#5C4EA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584C9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: -0.00186723,
    y1: 42.5423,
    x2: 56.2813,
    y2: 42.5423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8459A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1156,
    stopColor: "#7A56A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3984,
    stopColor: "#6750A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6897,
    stopColor: "#5C4D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584C9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 10.0959,
    y1: 42.5423,
    x2: 66.379,
    y2: 42.5423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A177B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#9570B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3033,
    stopColor: "#7A60A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5266,
    stopColor: "#6755A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7558,
    stopColor: "#5C4EA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584C9F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.31ab00c7e09698bde2259894dd6dc7b9.svg";
export { ForwardRef as ReactComponent };